import { FormProvider } from 'react-hook-form';
import { LiliTextArea } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { ControllerWrapper } from '@Hooks/index.ts';
import { EddEmbeddedFields } from '../fields.types';
import { useWhyDidYouChooseLogic } from './useWhyDidYouChooseLogic';

export const WhyDidYouChoose = () => {
  const { formMethods, handleSubmit } = useWhyDidYouChooseLogic();
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        formMethods={formMethods}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('embedded.c.question')}
        textCustomStyle='mt-[24px] text-text-main-primary text-[16px]'
        headingContainerCustomStyle='!mb-[16px]'
        handleSubmit={handleSubmit}
        text={t('embedded.c.content')}>
        <ControllerWrapper
          name={EddEmbeddedFields.EDD_EMBEDDED_WHY_DID_YOU_CHOOSE}
          control={formMethods.control}>
          {({ value, onChange, error, onBlur }) => (
            <LiliTextArea
              id={EddEmbeddedFields.EDD_EMBEDDED_WHY_DID_YOU_CHOOSE}
              value={value}
              onValueChange={(val) => onChange(val)}
              errorMsg={error?.message}
              externalErrorMessage={error?.message}
              maxLength={300}
              minHeight='min-h-[174px]'
              onBlur={onBlur}
              placeholder={t('embedded.c.placeholder')}
            />
          )}
        </ControllerWrapper>
      </StepPageWrapper>
    </FormProvider>
  );
};
